import Vue from 'vue';
import Vuex from 'vuex';
import frame from './modules/frame';
import app from './modules/app';
import user from './modules/user';
import tagsView from './modules/tagsView'
import wxAccount from "./modules/wxAccount";
import wxUserTags from "./modules/wxUserTags";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    frame,
    app,
    user,
    tagsView,
    wxUserTags,
    wxAccount,
  },
});

export default store;
